var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 37,
    viewBox: "0 0 20 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14676 27.699V34.8538H17.7847V27.699L19.9314 25.7567V35.5694L17.7847 37H2.14676L0 35.5694V25.7567L2.14676 27.699Z",
    fill: "#F9FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14676 24.735V16.3535L10.1188 24.3261L17.7847 16.3535V24.735L19.9314 23.3038V11.6516L10.1188 21.0554L0 11.6516V23.2016",
    fill: "#F9FAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3895 10.9366V8.38092H6.54143V12.3672L11.2433 17.0691L9.81213 18.4997L4.7019 13.0828V8.07424L6.54143 6.23471H13.3895L15.2296 7.66533V12.3672L13.3895 10.9366Z",
    fill: "#F9FAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3895 24.0194V29.028H6.54143V25.4506L4.7019 24.0194V29.4363L6.13252 30.8675H13.3895L15.2296 29.028V22.1793L13.3895 24.0194Z",
    fill: "#F9FAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7847 10.8344V1.83953H2.14676V10.8344L0 9.09652V1.83953L1.84008 0H18.0914L19.9314 1.53284V9.09652L17.7847 10.8344Z",
    fill: "#F9FAFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1936 1.4306H1.53339V2.14619H18.1936V1.4306Z",
    fill: "#F9FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8ea61424334a4200192e99ee14f89645.svg";
export { ForwardRef as ReactComponent };